import {
  Container,
  ContentContainer,
  HeaderImage,
  PostHeader,
  Title,
  Subtitle,
  Grid,
  Divider,
} from './style'
import { Notice, WarnNotice, CustomNotice } from './Notice'

export {
  Container,
  ContentContainer,
  HeaderImage,
  PostHeader,
  Title,
  Subtitle,
  Notice,
  WarnNotice,
  CustomNotice,
  Grid,
  Divider,
}
